import {createSelector} from 'reselect';
import props from '../../props';

export default createSelector(
    props.app.chime_recipient,
    props.app.chime_order,
    props.app.buttons.chime_create_button,
    (chime_recipient, chime_order, button) => {
        return {
            chime_recipient,
            chime_order,
            button
        }
    }
)